import React     from 'react';
import Constants from '../../../flux/Constants';
import Flux      from '../../../flux/Flux';
import PropTypes from 'prop-types';

/**
 * @param {React.Component|Function} Component
 * @return {React.Component}
 */
const withNinetyDaysRating = Component => {
	class NinetyDaysRatingContainer extends React.Component {

		/**
		 * @param {Number} actorId
		 * @return {null}
		 */
		static getRatings(actorId) {
			return Flux.Actor.getActorChatRatings(actorId, Constants.ChatRatings.LAST_NINETY_DAYS);
		}

		constructor(props) {
			super(props);

			this.state = {
				rating: NinetyDaysRatingContainer.getRatings(this.props.actorId),
			};

			this.onActorChatRatingsChanged = this.onActorChatRatingsChanged.bind(this);
		}

		UNSAFE_componentWillMount() {
			Flux.Actor.addActorChatRatingsChangeListener(this.onActorChatRatingsChanged);

			if (this.state.rating === null) {
				Flux.Actor.loadChatRatings(this.props.actorId);
			}
		}

		componentWillUnmount() {
			Flux.Actor.removeActorChatRatingsChangeListener(this.onActorChatRatingsChanged);
		}

		/**
		 * @param {Number} actorId
		 */
		onActorChatRatingsChanged(actorId) {
			if (actorId !== this.props.actorId) {
				return;
			}

			this.setState((state, props) => ({
				rating: NinetyDaysRatingContainer.getRatings(props.actorId),
			}));
		}

		render() {
			// do not pass through rating object if does not suit the domain logic
			const rating = Flux.Actor.shouldShowRating(this.props.actorId, Constants.ChatRatings.LAST_NINETY_DAYS) ? this.state.rating : null;

			return <Component {...this.props} rating={rating} />;
		}
	}

	NinetyDaysRatingContainer.propTypes = {
		actorId: PropTypes.number,
	};

	return NinetyDaysRatingContainer;
};

export default withNinetyDaysRating;
